<script setup>
defineProps({
  title: {
    type: String,
    default: '',
  },
  description: {
    type: String,
    default: '',
  },
  color: {
    type: String,
    default: 'danger', // Default to danger for error/warning
    validator: value =>
      [
        'primary',
        'secondary',
        'success',
        'danger',
        'warning',
        'info',
        'light',
        'dark',
      ].includes(value),
  },
  icon: {
    type: String,
    default: 'fa-circle-exclamation', // Default icon
  },
  // Adds an x in the corner; the parent decides what dismissing means.
  closable: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['close']);
</script>
<template>
  <div
    class="alert d-flex align-items-start"
    :class="`alert-${color}`"
    role="alert"
  >
    <div class="icon-container me-3">
      <i :class="`fa fa-solid ${icon}`" />
    </div>
    <div class="content">
      <h5 class="alert-heading mb-1">{{ title }}</h5>
      <p class="mb-0">{{ description }}</p>
    </div>
    <button
      v-if="closable"
      type="button"
      class="btn-close ms-3"
      :aria-label="$t('button.common.close')"
      @click="$emit('close')"
    />
  </div>
</template>
<style scoped>
.alert {
  border-radius: 8px;
  border-left-width: 4px;
  padding: 1rem;
}

.icon-container {
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  flex: 1;
}

h5.alert-heading {
  font-size: 1rem;
  font-weight: 600;
}

p {
  font-size: 0.875rem;
}
</style>
